<template>
    <div>
        <nav id="mainnavMobile" class="inMobile nav-mobile-manager">
            <ul class="container">
                <li><a href="#">初めて<br class="sp">の方<span class="pc">へ</span></a></li>
                <li><a href="#"><span class="pc">頼める</span>仕事の<br class="sp">種類</a></li>
                <li><a href="#">職人を<br class="sp">探す</a></li>
                <li><a href="#"><span class="pc">公開中の</span>依頼を<br class="sp">見る</a></li>
                <li class="sp"><a href="#">案件を<br class="sp">投稿</a></li>
            </ul>
        </nav>
        <nav id="mainnavMobileWorker" class="inMobile nav-mobile-worker">
            <ul class="container">
                <li><a href="#">初めて<br class="sp">の方<span class="pc">へ</span></a></li>
                <li><a href="#"><span class="pc">頼める</span>仕事の<br class="sp">種類</a></li>
                <li><a href="#">仕事を<br class="sp">探す</a></li>
                <li><a href="#"><span class="pc">公開中の</span>依頼を<br class="sp">見る</a></li>
                <li class="sp"><a href="#">案件を<br class="sp">検索</a></li>
            </ul>
        </nav>
    </div>
</template>

<script>
    export default {
        name: "menu-mobile"
    }
</script>

<style scoped>

</style>
